import React from 'react'
import AddIcon from '@material-ui/icons/Add'
import ButtonToolbar from '../../components/ButtonToolbar'
import { useDispatch } from 'react-redux'
import { CategoriesActionTypes } from '../../store/categories/categoriesTypes'
import { useMediaQuery } from '@material-ui/core'

export default function CategoriesToolbar() {
  const dispatch = useDispatch()
  const matches = useMediaQuery('(min-width: 600px)')

  return (
    <>
      <ButtonToolbar
        text="Novo cadastro"
        matches={matches}
        IconLeft={AddIcon}
        onClick={() => dispatch({ type: CategoriesActionTypes.EDITING_START })}
      />
    </>
  )
}
